// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__1QD7q"};